// @flow
import { createSelector } from 'reselect'

const studies = (state) => state.study.studies

export const getStudies = createSelector(
  [studies],
  (studies) => studies
)

const currentStudy = (state) => state.study.currentStudy

export const getCurrentStudy = createSelector(
  [currentStudy],
  (currentStudy) => currentStudy
)

const deleteStudy = (state) => state.study.deleteStudy

export const getDeleteStudy = createSelector(
  [deleteStudy],
  (deleteStudy) => deleteStudy
)

const newStudy = (state) => state.study.newStudy

export const getNewStudy = createSelector(
  [newStudy],
  (newStudy) => newStudy
)

const updateStudy = (state) => state.study.updateStudy

export const getUpdateStudy = createSelector(
  [updateStudy],
  (updateStudy) => updateStudy
)

const updateStudyPhoto = (state) => state.study.updateStudyPhoto

export const getUpdateStudyPhoto = createSelector(
  [updateStudyPhoto],
  (updateStudyPhoto) => updateStudyPhoto
)
